import { ACTIONS } from "../../common/constants";

const userDetailsReducer = function (state = null, action) {
  switch (action.type) {
    case ACTIONS.SET_USER_DATA:
      return action.data;
    default:
      return state;
  }
};

export default userDetailsReducer;
